module.exports = { id: "plus", url: "/build/app/img/symbols.svg#plus", viewBox: "", toString: function() { return this.url; } };